import { useEffect, useRef, useState } from 'react'
import './planner.css'

/**
 * Overflow menu for an assigned meal row.
 * Cook nights: Move / Swap recipe / Remove.
 * Easy nights: Change this night / Move / Leave open.
 */
export default function MealRowActionsMenu({
  onMove,
  onSwap,
  onRemove,
  nightOff = false,
  disabled = false,
}) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', onDoc)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDoc)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  if (disabled) return null

  return (
    <div className="meal-row-actions-menu" ref={ref}>
      <button
        type="button"
        className="meal-row-actions-menu-trigger"
        aria-label={nightOff ? 'Night options' : 'Meal options'}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(e) => {
          e.stopPropagation()
          setOpen((v) => !v)
        }}
      >
        ⋮
      </button>
      {open && (
        <div className="meal-row-actions-menu-popover" role="menu">
          {nightOff ? (
            <button
              type="button"
              className="meal-row-actions-menu-item"
              role="menuitem"
              onClick={(e) => {
                e.stopPropagation()
                setOpen(false)
                onSwap?.()
              }}
            >
              Change this night
            </button>
          ) : null}
          <button
            type="button"
            className="meal-row-actions-menu-item"
            role="menuitem"
            onClick={(e) => {
              e.stopPropagation()
              setOpen(false)
              onMove?.()
            }}
          >
            Move to another day
          </button>
          {nightOff ? null : (
            <button
              type="button"
              className="meal-row-actions-menu-item"
              role="menuitem"
              onClick={(e) => {
                e.stopPropagation()
                setOpen(false)
                onSwap?.()
              }}
            >
              Swap recipe
            </button>
          )}
          <button
            type="button"
            className={`meal-row-actions-menu-item${nightOff ? '' : ' is-danger'}`}
            role="menuitem"
            onClick={(e) => {
              e.stopPropagation()
              setOpen(false)
              onRemove?.()
            }}
          >
            {nightOff ? 'Leave this night open' : 'Remove from plan'}
          </button>
        </div>
      )}
    </div>
  )
}
